"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CozyLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _ArrowBack = _interopRequireDefault(require("@quintoandar/cozy-icons/ArrowBack"));
var _Intl = _interopRequireDefault(require("../proptypes/Intl"));
var _proptypes = require("./proptypes");
var _AnchorText = _interopRequireDefault(require("./AnchorText"));
var _CaptionText = _interopRequireDefault(require("./CaptionText"));
var _Link = _interopRequireWildcard(require("./Link"));
var _messages = _interopRequireDefault(require("./messages"));
var _excluded = ["message", "icon", "ariaLabel", "rel", "typographyProps", "backIcon", "underline", "caption"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var getCaptionLevelFromTypographyProps = function getCaptionLevelFromTypographyProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    level = _ref.level;
  var captionMapper = {
    display: 'body',
    heading: 'body',
    title: 'body',
    body: 'body',
    caption: 'caption'
  };
  return captionMapper[level] || captionMapper.caption;
};
var getLinkKindFromVariant = function getLinkKindFromVariant(variant) {
  return variant === 'inverse' ? 'inverse' : 'default';
};
var getCaptionKindFromVariant = function getCaptionKindFromVariant(variant) {
  return variant === 'inverse' ? 'inverseLighter' : 'lighter';
};
var getIconPropsFromTypographyProps = function getIconPropsFromTypographyProps() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    level = _ref2.level;
  var iconFontSizeMapper = {
    display: {
      fontSize: 'default'
    },
    heading: {
      fontSize: 'default'
    },
    title: {
      fontSize: 'small'
    },
    body: {
      fontSize: 'small'
    },
    caption: {
      style: {
        width: '12px',
        height: '12px'
      }
    } // TODO - We have an exception here, icon should be 12px/12px - We should refactor this later
  };
  return iconFontSizeMapper[level] || iconFontSizeMapper.body;
};
var CozyLink = exports.CozyLink = function CozyLink(_ref3) {
  var message = _ref3.message,
    Icon = _ref3.icon,
    ariaLabel = _ref3.ariaLabel,
    rel = _ref3.rel,
    typographyProps = _ref3.typographyProps,
    backIcon = _ref3.backIcon,
    underline = _ref3.underline,
    caption = _ref3.caption,
    props = _objectWithoutProperties(_ref3, _excluded);
  var intl = (0, _reactIntl.useIntl)();
  var linkMessage = message.defaultMessage ? intl.formatMessage(message, message.values) : message;
  var defaultAriaLabel = props.target === _proptypes.LinkTarget.BLANK ? "".concat(linkMessage, " ").concat(intl.formatMessage(_messages["default"].blank)) : undefined;
  var isButton = !(props.href || props.to) && !!props.onClick;
  var shouldShowIcon = Boolean(Icon && !backIcon);
  var defaultProps = isButton ? {
    component: 'button'
  } : {
    rel: rel
  };
  return /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({
    "aria-label": ariaLabel || defaultAriaLabel,
    isButton: isButton,
    hasIcon: shouldShowIcon,
    backIcon: backIcon,
    typographyProps: typographyProps,
    underline: underline
  }, defaultProps, props), /*#__PURE__*/_react["default"].createElement(_AnchorText["default"], _extends({
    as: "span",
    underline: underline,
    kind: getLinkKindFromVariant(props.variant)
  }, typographyProps), /*#__PURE__*/_react["default"].createElement(_Link.DecorationText, {
    kind: getLinkKindFromVariant(props.variant)
  }, backIcon && /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], getIconPropsFromTypographyProps(typographyProps)), linkMessage, shouldShowIcon && /*#__PURE__*/_react["default"].createElement(Icon, getIconPropsFromTypographyProps(typographyProps)))), caption && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CaptionText["default"], {
    underline: underline,
    kind: getCaptionKindFromVariant(props.variant),
    level: getCaptionLevelFromTypographyProps(typographyProps)
  }, /*#__PURE__*/_react["default"].createElement(_Link.DecorationText, {
    kind: getCaptionKindFromVariant(props.variant)
  }, caption))));
};
CozyLink.propTypes = process.env.NODE_ENV !== "production" ? {
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _Intl["default"]]).isRequired,
  icon: _propTypes["default"].elementType,
  backIcon: _propTypes["default"].bool,
  ariaLabel: _propTypes["default"].string,
  to: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  href: _propTypes["default"].string,
  rel: _proptypes.LinkRelPropType,
  target: _proptypes.LinkTargetPropType,
  variant: _proptypes.LinkVariantPropType,
  onClick: _propTypes["default"].func,
  typographyProps: _propTypes["default"].any,
  underline: _propTypes["default"].bool,
  caption: _propTypes["default"].string
} : {};
CozyLink.defaultProps = {
  rel: _proptypes.LinkRel.NOREFERRER,
  variant: _proptypes.LinkVariants.DEFAULT,
  backIcon: false,
  underline: true,
  caption: ''
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CozyLink);